import { GenericService } from './generic-service'

class IdiomaService extends GenericService {
  constructor () {
    super('/idiomas')
  }
}

export default new IdiomaService()
